import { cn } from "@/lib/utils";

import type { Figure } from "./wire";

/**
 * A card's figures as label over value, full values that wrap rather than truncate: two columns,
 * four once the card is wide enough for them (its own width, not the window's). `className` goes
 * on the grid, to set its columns another way.
 */
export function FigureGrid({ figures, className }: { figures: Figure[]; className?: string }) {
  return (
    <div className="[container-type:inline-size]">
      <dl
        className={cn(
          "grid grid-cols-2 gap-x-3.5 gap-y-2.5 [@container(min-width:28rem)]:grid-cols-4",
          className
        )}
      >
        {figures.map((figure, index) => (
          <div key={index} className="min-w-0">
            <dt className="text-[11px] uppercase tracking-[0.06em] text-muted-foreground">
              {figure.label}
            </dt>
            <dd className="break-words text-sm font-semibold tabular-nums">{figure.value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
